import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: "center",
    marginRight: "10px"
  },
}));

export default useStyles;